<template>
  <div
    :class="tabActiveClass"
    id="comercial"
    role="tabpanel"
    aria-labelledby="comercial-tab"
  >
    <h4 class="form-title hide-mobile">{{ transPeralbaPro.item841 }}</h4>
    <hr class="hide-mobile" />
    <div class="row">
      <div class="col-md-6">
        <h5 class="form-subtitle">{{ transPeralbaPro.item858 }}</h5>
        <p class="form-subtitle-p">{{ transPeralbaPro.item859 }}</p>
      </div>
      <div class="col-md-6">
        <label
          ><input type="checkbox" @change="copyFiscalData($event)" />
          {{ transPeralbaPro.item1007 }}</label
        >

        <br />
        <form-input
          fieldName="nombreComercial"
          :fieldLabel="transPeralbaPro.item860"
          fieldType="text"
          :fieldValue="nombreComercial"
          :inputPlaceholder="transPeralbaPro.item860"
          :is-required="true"
          :has-error="fieldHasErrors('comercialData', 'nombreComercial')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="comercialAddress"
          :fieldLabel="transPeralbaPro.item861"
          fieldType="text"
          :fieldValue="comercialAddress"
          :inputPlaceholder="transPeralbaPro.item861"
          :is-required="true"
          :has-error="fieldHasErrors('comercialData', 'comercialAddress')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="personaContacto"
          :fieldLabel="transPeralbaPro.item862"
          fieldType="text"
          :fieldValue="personaContacto"
          :inputPlaceholder="transPeralbaPro.item862"
          :is-required="true"
          :has-error="fieldHasErrors('comercialData', 'personaContacto')"
          @updateValue="updateFormValue"
        />
        <form-input
          fieldName="cargoEmpresa"
          :fieldLabel="transPeralbaPro.item863"
          fieldType="text"
          :fieldValue="cargoEmpresa"
          :inputPlaceholder="transPeralbaPro.item863"
          :is-required="true"
          :has-error="fieldHasErrors('comercialData', 'cargoEmpresa')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="emailComercial"
          :fieldLabel="transPeralbaPro.item793"
          fieldType="email"
          :fieldValue="emailComercial"
          :inputPlaceholder="transPeralbaPro.item793"
          :is-required="true"
          :has-error="fieldHasErrors('comercialData', 'emailComercial')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="mobileComercial"
          :fieldLabel="transPeralbaPro.item824"
          fieldType="telephone"
          :fieldValue="mobileComercial"
          :inputPlaceholder="transPeralbaPro.item824"
          :is-required="true"
          :has-error="fieldHasErrors('comercialData', 'mobileComercial')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="phoneComercial"
          :fieldLabel="transPeralbaPro.item825"
          fieldType="telephone"
          :fieldValue="phoneComercial"
          :inputPlaceholder="transPeralbaPro.item826"
          :has-error="fieldHasErrors('comercialData', 'phoneComercial')"
          @updateValue="updateFormValue"
        />
      </div>

      <div class="col-md-6">
        <h5 class="form-subtitle">{{ transPeralbaPro.item864 }}</h5>
        <p class="form-subtitle-p">{{ transPeralbaPro.item865 }}</p>
      </div>
      <div class="col-md-6">
        <form-select
          fieldName="selectedWarehouse"
          :fieldLabel="transPeralbaPro.item709"
          :fieldValue="selectedWarehouse"
          :options="warehouses"
          :is-required="true"
          :has-error="fieldHasErrors('comercialData', 'selectedWarehouse')"
          @updateValue="updateFormValue"
        />

        <form-select
          fieldName="selectedActivity"
          :fieldLabel="transPeralbaPro.item866"
          :fieldValue="selectedActivity"
          :options="activityWorkers"
          :is-required="true"
          :has-error="fieldHasErrors('comercialData', 'selectedActivity')"
          @updateValue="updateFormValue"
        />

        <form-select
          v-if="selectedActivity && selectedActivity == 1"
          fieldName="selectedPrincipalActivity"
          :fieldLabel="transPeralbaPro.item867"
          :fieldValue="selectedPrincipalActivity"
          :options="activityGeneralWorkers"
          :is-required="true"
          :has-error="
            fieldHasErrors('comercialData', 'selectedPrincipalActivity')
          "
          @updateValue="updateFormValue"
        />
      </div>
    </div>

    <div class="w-100" style="height: 100px">
      <button
        type="button"
        :disabled="disabledForm"
        class="btn-per-dark-outlined mt-4 mb-2"
        @click="$emit('goToDatosFiscales')"
        style="float: left"
      >
        <i class="fas fa-arrow-left me-3"></i>{{ transPeralbaPro.item833 }}
      </button>
      <button
        type="button"
        :disabled="disabledForm"
        class="btn-per-dark mt-4 mb-2"
        @click="$emit('validateRegisterComercialData')"
        style="float: right"
      >
        {{ transPeralbaPro.item827 }}<i class="fas fa-arrow-right ms-3"></i>
      </button>
    </div>
  </div>
</template>
<script>
import FormInput from "../../../../../components/front/Inputs/FormInput";
import FormRadioButton from "../../../../../components/front/Inputs/FormRadioButton";
import FormSelect from "../../../../../components/front/Inputs/FormSelect.vue";
import sections from "../../mixins/sections";
export default {
  mixins: [sections],
  components: { FormInput, FormRadioButton, FormSelect },
  props: [
    "activeTab",
    "nombreComercial",
    "emailComercial",
    "selectedActivity",
    "activityWorkers",
    "comercialAddress",
    "disabledForm",
    "comercialAddress",
    "personaContacto",
    "cargoEmpresa",
    "mobileComercial",
    "phoneComercial",
    "selectedPrincipalActivity",
    "activityGeneralWorkers",
    "selectedWarehouse",
    "warehouses",
    "errors",
    "transPeralbaPro",
    "fiscalName",
    "fiscalAddress",
    "email",
    "nombreAdmin",
    "mobileAdmin",
    "phoneAdmin",
  ],
  methods: {
    copyFiscalData(event) {
      this.$nextTick(() => {
        if (event.target.checked) {
          this.$emit("updateField", {
            field: "nombreComercial",
            value: this.fiscalName,
          });
          this.$emit("updateField", {
            field: "comercialAddress",
            value: this.fiscalAddress,
          });
          this.$emit("updateField", {
            field: "emailComercial",
            value: this.email,
          });
          this.$emit("updateField", {
            field: "personaContacto",
            value: this.nombreAdmin,
          });
          this.$emit("updateField", {
            field: "mobileComercial",
            value: this.mobileAdmin,
          });
          this.$emit("updateField", {
            field: "phoneComercial",
            value: this.phoneAdmin,
          });
        }
      });
    },
  },
};
</script>
